import { useEffect } from 'react';
import { Auth } from 'aws-amplify';
import { RouteComponentProps } from 'react-router-dom';
import { Footer, Header } from 'components';
import VideoContent from './components/VideoModules';
import MedicsComponent from '../../components/Medics';
import WelcomeVideo from './components/WelcomeVideo';
import PregnancyMoments from './components/PregnancyMoments';
import TestimonialsSection from './components/Testimonials';
import { MainBtn } from 'components/Buttons';
import smoothscroll from 'smoothscroll-polyfill';

import {
  LandingPageContainer,
  LandingPageResume,
  LandingPageButtonSubscribe,
  Highlight,
  Title,
  Container,
  IconContainer,
  Text,
  BannerContainer,
  ImageSection,
  ContentSection,
  Description,
  StatsContainer,
  StatItem,
  StatNumber,
  StatLabel,
  ButtonContainer,
  SubscribeButton,
  TitleBanner,
} from './style';

import { socialLogin } from 'services/login';
import { ButtonSection } from './components/WelcomeVideo/style';

smoothscroll.polyfill();

interface props extends RouteComponentProps {}

function LandingPage({ history }: props) {
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('exeltis-user') as string);

    if (user) {
      history.push('/home');
    }
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const response = await Auth.currentSession();
        const accessToken = response.getAccessToken().getJwtToken();
        const idToken = response.getIdToken().getJwtToken();

        const loginInfo = await socialLogin({
          access_token: accessToken,
          id_token: idToken,
        });

        if (loginInfo) {
          localStorage.setItem('exeltis-api-token', loginInfo.api_token);
          localStorage.setItem('exeltis-user', JSON.stringify(loginInfo.user));

          history.push('/home');
        }
      } catch (error) {}
    })();
  }, []);

  return (
    <LandingPageContainer>
      <Header reduceHeader={false} showHeaderNotLogged />

      <WelcomeVideo />
      <PregnancyMoments />

      <LandingPageResume>
        <Container>
          <IconContainer>
            <svg
              width="19"
              height="16"
              viewBox="0 0 19 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.94975 0.999945H2.38211C1.61881 0.999945 1 1.61875 1 2.38206V13.8536C1 14.6169 1.61881 15.2357 2.38211 15.2357H16.6179C17.3812 15.2357 18 14.6169 18 13.8536V2.38206C18 1.61875 17.3812 0.999945 16.6179 0.999945H11.0595"
                stroke="#FFEAF6"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M1 11.0894H18"
                stroke="#FFEAF6"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M4.79825 13.1626C4.79825 13.5443 4.48887 13.8536 4.10719 13.8536C3.72552 13.8536 3.41614 13.5443 3.41614 13.1626C3.41614 12.7809 3.72552 12.4715 4.10719 12.4715C4.48887 12.4715 4.79825 12.7809 4.79825 13.1626Z"
                stroke="#FFEAF6"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6.97729 13.1626H15.5839"
                stroke="#FFEAF6"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M9.03935 4.44274L10.8541 5.49048C11.2807 5.73677 11.2807 6.35254 10.8541 6.59887L9.03935 7.64658C8.61272 7.89291 8.07947 7.58501 8.07947 7.09239V4.99693C8.07947 4.50431 8.61272 4.19641 9.03935 4.44274Z"
                stroke="#FFEAF6"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </IconContainer>
          <Text>Programa completo</Text>
        </Container>

        <Title>
          Método <Highlight>reGenesis</Highlight>
        </Title>

        <p style={{ textAlign: 'center', marginBottom: '20px' }}>
          Do primeiro trimestre de gravidez à amamentação, aqui você encontra
          conhecimento científico, acolhimento e apoio para cada etapa
        </p>

        <BannerContainer>
          <ImageSection />
          <ContentSection>
            <TitleBanner>100% online</TitleBanner>
            <Description>
              Flexibilidade para acessar de onde quiser, no seu tempo.
            </Description>

            <StatsContainer>
              <StatItem>
                <StatNumber>+9 horas</StatNumber>
                <StatLabel>de conteúdo</StatLabel>
              </StatItem>
              <StatItem>
                <StatNumber>+40 aulas</StatNumber>
                <StatLabel>Profissionais qualificados</StatLabel>
              </StatItem>
            </StatsContainer>

            <ButtonContainer>
              <SubscribeButton onClick={() => history.push('/signup')}>
                QUERO ME INSCREVER AGORA
              </SubscribeButton>
              <span style={{ marginLeft: '10px', fontSize: "11px" }}>100% online e gratuito mediante cupom de acesso</span>
            </ButtonContainer>
          </ContentSection>
        </BannerContainer>
      </LandingPageResume>

      <VideoContent />

      <MedicsComponent />

      <TestimonialsSection />

      <Footer backgroundColor={'var(--default-background-color)'} hasLogo />
    </LandingPageContainer>
  );
}

export default LandingPage;
